import { RootState } from 'app/store'

export const selectIsLoadingLogout = (state: RootState) => state.logoutReducer.isLoading
